module.exports = __webpack_public_path__ + "img/c3b2c60.svg";